<!-- @format -->

<template>
	<template v-if="formStatus === 'widget'">
		<Widget :item="item" v-bind="$attrs">
			<template #default="scope">
				<slot v-bind="scope"></slot>
			</template>
		</Widget>
	</template>
	<template v-else>
		<Render :item="item" :model-value="modelValue" v-bind="$attrs" />
	</template>
</template>

<script setup lang="ts">
	import Widget from './sub-table/widget.vue';
	import Render from './sub-table/render.vue';

	interface Props {
		item: any;
		modelValue?: any;
	}

	withDefaults(defineProps<Props>(), {});

	const formStatus = inject('form-status', 'widget');
</script>

<style scoped></style>
